export const discharge = {
    discharge_form: {
        SAPDeliveryNo:'',
        NominationReference:'',
        TransportVessel:'',
        DischargePort:'',
        ProductName:'',
        SurveyorCompany:'',
        BOLNo:'',

        PDBShipRef:'',
        VesselName:'',
        PortType:'',
        PortName:'',
        Density:'',

        OutturnQuantityL:'',

        BLQuantityBBL:'',
        VLQuantityBBL:'',
        VAQuantityBBL:'',
        OutturnQuantityBBL:'',
        LineDisplacementQuantityBBL:'',

        BLQuantityMT:'',
        VLQuantityMT:'',
        VAQuantityMT:'',
        OutturnQuantityMT:'',
        LineDisplacementMT:'',

        BLvsVLBBL:'',
        BLvsVLBBLPercent:'',
        VLvsVABBL:'',
        VLvsVABBLPercent:'',
        VAvsOutturnBBL:'',
        VAvsOutturnBBLPercent:'',

        BLvsVLMT:'',
        BLvsVLMTPercent:'',
        VLvsVAMT:'',
        VLvsVAMTPercent:'',
        VAvsOutturnMT:'',
        VAvsOutturnMTPercent:'',
        
        GrossTransitLossBBL:'',
        GrossTransitLossBBLPercent:'',
        NetTransitLossBBL:'',
        NetTransitLossBBLPercent:'',

        GrossTransitLossMT:'',
        GrossTransitLossMTPercent:'',
        NetTransitLossMT:'',
        NetTransitLossMTPercent:'',
        
        StartDischargeTimestamp:'',
        StartDischargeTimestampLocale:'',
        CompleteDischargeTimestamp:'',
        CompleteDischargeTimestampLocale:'',
        EstimatedTimeArrival:'',
        EstimatedTimeArrivalLocale:'',
        EstimatedTimeBerthing:'',
        EstimatedTimeBerthingLocale:'',
        NORTendered:'',
        NORTenderedLocale:'',
        POBUnberthing:'',
        POBUnberthingLocale:'',
        CreatedTimestamp:'',
        ModifiedTimestamp:'',

        //additional information not required by dove
        Temperature:'',

        ReportFilename: 'Discharge',
        DateCreated: '',
        ModifyBy: '',
        ReportStatus: '',
        Product:'',
    },
    read_data:{},
    is_submit_loading: false,
    is_form_loading:false
}



// WEBPACK FOOTER //
// ./src/reducers/discharge/discharge.state.js